
$(function(){

var winWidth = $( window ).width();

 $('#fullpage').fullpage({
 	navigation: true,
 	anchors:['smysly', 'sluch', 'dotek', 'cich', 'zrak', 'chut', 'my', 'mapa'],
 	responsive: 1026,
 	fitToSection: true,
 	slidesNavigation: true,
  licenseKey: '4D0D4BE2-C1864D37-A9BBF8B4-5FA6317C'
 });

 $('#detailP').fullpage({
 	navigation: true,
 	responsive: 1026,
 	fitToSection: true,
 	slidesNavigation: true,
  loopHorizontal: false,
  licenseKey: '4D0D4BE2-C1864D37-A9BBF8B4-5FA6317C'
 });

// on click change url withou reloading page
  function returnSlug() {
   var activeChild = $('#detailP .fp-slidesContainer').find('.slide.active'),
           newUrl = "/detail/" + activeChild.attr("data-anchor");
   history.replaceState(window.location.href, null, newUrl);
  }

 function returnNextSlug() {
   var activeChild = $('#detailP .fp-slidesContainer').find('.slide.active'),
       newUrl = "/detail/" + activeChild.next().attr("data-anchor");
   return history.replaceState(window.location.href, null, newUrl);
 }

 function returnPrevSlug() {
   var activeChild = $('#detailP .fp-slidesContainer').find('.slide.active'),
       newUrl = "/detail/" + activeChild.prev().attr("data-anchor");
   return history.replaceState(window.location.href, null, newUrl);
 }

 var firstSlide = $('#detailP .fp-slidesContainer .slide:first-child'),
     lastSlide = $('#detailP .fp-slidesContainer .slide:last-child');
 
 $('.fp-next').on('click', function(e) {
    e.preventDefault();
    returnNextSlug();
 }); 

 $('.fp-prev').on('click', function(e) {
    e.preventDefault();
    returnPrevSlug();
 });


 $('.carousel').carousel({
   interval: 500000
 })

 //methods
 // $.fn.fullpage.setAllowScrolling(true);

 // if ( winWidth < 1025 ) {
 // 	fullpage_api.setResponsive(true)
 // }

 // alert fadeout
 $('.alert').show().delay(5000).fadeOut(1000);

 // category select
 $('.select').on('click','.placeholder',function(){
   var parent = $(this).closest('.select');
   if ( ! parent.hasClass('is-open')){
     parent.addClass('is-open');
     $('.select.is-open').not(parent).removeClass('is-open');
   }else{
     parent.removeClass('is-open');
   }
 })

 $('#carIndicators').find('li').first().addClass('active');
 $('#carContent').find('.carousel-item').first().addClass('active');

  //  load more in references
  var boxes = $('#referencesList').find('.box'),
      button = $('#loadMore');

    boxes.addClass('hidden');
    boxes.slice(0, 6).removeClass('hidden').addClass('displayShow');

    if(boxes.length < 6 ) {
      button.hide();
    }

    button.on('click', function(event) {
      event.preventDefault();
      $('.box:hidden').slice(0 , 6).removeClass('hidden').addClass('displayShow').fadeIn(1000);
       if ($(".box:hidden").length == 0) {
           button.fadeOut('slow');
       }
    });

  // next step homepage
  $('#moreAbout').on('click', function(e) {
    fullpage_api.moveTo(2);
    e.preventDefault();
  });

  // floatin inputs
  $('.form-group').each(function(){
    changeState($(this));
  });

   $('.form-group').find('input, select, textarea').each(function(){
    $(this).focus(() => {
      $(this).parent().addClass('active');
    }).blur(() => {
      $(this).parent().removeClass('active');
    })
   });

  function changeState(input){
    var val = input.val();

    if( val && val.length > 0){
      input.parents('.form-group').addClass('has-value');
    } else{
      input.parents('.form-group').removeClass('has-value');
    }
  }

  $('.form-control').each(function(){
      changeState($(this));
  }).on('focusout change', function(){
      changeState($(this));
  });

  $('#focusRealSearchInput').on('focus click', function(){
    $('#search-bar-input').focus();
  });

  /*
   * Marek Gogol autoAjax forms
   */
  $('form.autoAjax').autoAjax();

  $('#moveRight').on('click', function(e) {
    e.preventDefault();
    fullpage_api.moveSlideRight();
  });

  $('#moveLeft').on('click', function(e) {
    e.preventDefault();
    fullpage_api.moveSlideLeft();
  });


    // autoHeight
    var winWidth = $( window ).width();
    var winHeight = $( window ).height();

    homeSection = $("body");

    function handleResize() {
        var mediaHeight = $(window).height();
        if(mediaHeight < 850) {
          homeSection.addClass('resizeByHeight');
        } else {
          homeSection.removeClass('resizeByHeight');
        }
    } 
    handleResize();
    $(window).resize(function(){ handleResize(); });

    detailSection = $(".detail-page .headline");

    function detailResize() {
        var mediaHeight = $(window).height();
        if(mediaHeight < 730) {
          detailSection.addClass('resizeByHeightDetail');
        } else {
          detailSection.removeClass('resizeByHeightDetail');
        }
    } 
    detailResize();
    $(window).resize(function(){ detailResize(); });

    if(winWidth < 768) {
      $('.contactUsNow').on('click', function() {
          $('#menu').animate({
              scrollTop: $(document).height()
            }, 1000);
      });
    }

  // var height = $(window).height(),
  //     bodyClass = $('body').hasClass('home-page');

  // if(height < 700 && height > 800 && bodyClass) {
  //   $('.info-g').hide();
  //   $('.list-inline-stroke').hide();
  // }


  // $(window).on('load', function() {
  //   $('#preLoader').delay(400).fadeOut('slow');
  //   $('body').delay(400).css({'overflow':'visible'});
  // });

  $('#contact').click(function(){
      $('#menu').modal('hide');
      $(document.body).scrollTop($('#anchorId').offset().top);
  });
  // hide menu on click
  $('#menu .menu-list').find('a').on('click', function(){
      $('#menu').modal('hide');
  });



});



// WEBPACK FOOTER //
// ./resources/assets/js/main.js